import e from "@dialpad/dialtone-tokens/layered/themes/tokens-cobalt-colors.css?inline";
//#region themes/cobalt.js
var t = {
	brand: {
		css: e,
		name: "cobalt"
	},
	material: { name: "iron" }
};
//#endregion
export { t as default };
